<div class="row mb-2">
  <label class="mb-1 col-sm-12" translate>Textarea label</label>
  <div class="col-sm-12">
    <input type="text" class="form-control form-control-sm" [(ngModel)]="component.element.label" (ngModelChange)="onLabelChange($event)" />
  </div>
</div>
<div class="mb-2 form-check">    
  <input type="checkbox" class="form-check-input" [(ngModel)]="component.element.show_label" id="show_label" /> 
  <label for="show_label" class="form-check-label" translate>Show label</label> 
</div>
<div class="row mb-2">
  <label class="mb-1 col-sm-12" translate>Placeholder text</label>
  <div class="col-sm-12">
    <input type="text" class="form-control form-control-sm" [(ngModel)]="component.element.placeholder_text"  />
  
  </div>
</div>
<div class="row mb-2">
  <label class="col-sm-12" translate>Field name</label>
   <div class="col-sm-12">
    <input type="text" name="field_name" [(ngModel)]="component.element.field_name" class="form-control form-control-sm"  maxlength="100">
    <small class="text-muted" translate> max 100 characters</small>
  </div>
</div>
<div class="form-check">
  <input type="checkbox" class="form-check-input" [(ngModel)]="component.element.is_required" id="is_required" />
  <label for="is_required" class="form-check-label" translate>Set as required</label>       
</div>

